let suppliersEdit = () => import('../app/Components/Views/Suppliers/CompaniesEdit.vue') // tabs de editar -->
let CustomersEdit = () => import('../app/Components/Views/Customers/CompaniesEdit.vue')  // tabs de editar customers

let tab2 = () => import('../app/Components/Views/Customers/tabs/ComponentsTabs.vue')  // tabs de editar customers
let tab3 = () => import('../app/Components/Views/Customers/tabs/ComponentsTabs3.vue')  // tabs de editar customers


//suppliers
let tab4 = () => import('../app/Components/Views/Suppliers/tabs/tabsContacts.vue')  // tabs de editar customers

let tab5 = () => import('../app/Components/Views/Suppliers/tabs/tabsAddress.vue')  // tabs de editar customers

export default [

    {
        path: '/suppliers/details',
        component: suppliersEdit,    
        name: 'companies-details'
    },

    {
        path: '/customers/details',
        component: CustomersEdit,    
        name: 'customers-details'
    },


    {
        path: '/cust/conta',
        component: tab2,    
        name: 'Contacts'
    },


    {
        path: '/cust/address',
        component: tab3,    
        name: 'Shipping Addresses'
    },

    {
        path: '/supplier/conta',
        component: tab4,    
        name: 'Contacts-suppliers'
    },


    {
        path: '/supplier/address',
        component: tab5,    
        name: 'Addresses-suppliers'
    },




    

]